import { render, staticRenderFns } from "./LinkCommon.vue?vue&type=template&id=738c94fe&"
import script from "./LinkCommon.vue?vue&type=script&lang=ts&"
export * from "./LinkCommon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports